module.exports = __webpack_public_path__ + "newprotal/img/qq2.557b0732.png";